<div class="approval-bar change-request-approval-bar">
  <ol class="change-request-status-list">
    <li [class.approval-active-state]="isDraftStatusActive()">
      <span class="status-label">Draft</span>
      <change-request-tooltip
        [visible]="isDraftStatusActive() && canSubmit() && canEditChangeRequest()"
        [changeRequestStatus]="changeRequest.status"
        (onSubmitDraft)="submitDraft()">
      </change-request-tooltip>
    </li>
    <li [class.approval-active-state]="isStatusHighlighted(ChangeRequestStatus.CLIENT_APPROVED)">
      <span class="status-label">In client approval</span>
      <change-request-tooltip
        [visible]="isClientApprovalActive() && canEditChangeRequest()"
        [changeRequestStatus]="ChangeRequestStatus.CLIENT_APPROVED"
        (onBackToDraft)="backToDraft()"
        (onDismiss)="dismiss()"
        (onMergeToScope)="mergeToScope()">
      </change-request-tooltip>
    </li>
    <li [class.approval-active-state]="isStatusHighlighted(ChangeRequestStatus.MERGED_CLOSED)">
      <span class="status-label">Accepted and merged</span>
    </li>
    <li class="divider-v"></li>
    <li [class.approval-active-state]="isStatusHighlighted(ChangeRequestStatus.AGENCY_APPROVED)">
      <span class="status-label">Trafficked</span>
    </li>
    <li class="divider-v"></li>
    <li [class.approval-active-state]="isStatusHighlighted(ChangeRequestStatus.UNMERGED_CLOSED)">
      <span class="status-label">Dismissed</span>
    </li>
  </ol>

  <div class="approval-collaborators">
    <div
      class="approval-collaborators-list"
      *ngIf="collaborators?.length">
      <div
        class="collaborator-avatar"
        *ngFor="let member of collaborators | slice: 0 : MAX_VISIBLE_COLLABORATORS">
        <span>{{ getInitials(member) }}</span>
      </div>
      <div
        class="collaborator-avatar collaborator-more"
        *ngIf="getRemainingCollaborators() > 0">
        <span>+{{ getRemainingCollaborators() }}</span>
      </div>
    </div>

    <button
      type="button"
      class="scope-output"
      (click)="openOutput()">
      <span><i class="material-symbols-rounded">download</i></span>
      <span>Output</span>
    </button>

    <button
      type="button"
      class="scope-traffic"
      (click)="openTraffic()">
      <span><i class="material-symbols-rounded">swap_vert</i></span>
      <span>Traffic</span>
    </button>
  </div>
</div>
